import React from 'react';
import DataDisplay from '../DataDisplay/Desktop';

function FuelPrices(props) {
  const prices = props.data.map((item, key) => (<DataDisplay key={key} label={item.name} data={item.price} />));
  const lastUpdate = Math.floor((new Date().getTime() - props.lastUpdate) / 1000 / 60);
  let messageUpdate = 'Last retrieved ';

  if(lastUpdate < 1) {
    messageUpdate += 'less than 1 minute';
  } else if (lastUpdate === 1) {
    messageUpdate += '1 minute';
  } else {
    messageUpdate += `${lastUpdate} minutes`;
  }

  messageUpdate += ' ago';

  return (
    <div className="fuel-container">
      <div className="prices">
        {prices}
      </div>
      <div className="fuel-updated">
        { messageUpdate }
      </div>
    </div>
  )
}

export default FuelPrices;


/** WEBPACK FOOTER **
 ** ./src/FuelPrices/FuelPrices.js
 **/